import React, { useState } from "react";
import { motion } from "framer-motion";
import { goToCheckout } from "@/lib/checkout";
import { trackInitiateCheckout } from "@/lib/analytics";
import { ChevronRight, Loader2, Lock } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const SIZES = {
  md: "px-7 py-4 text-sm md:text-base",
  lg: "px-9 py-5 text-sm md:text-base",
  xl: "px-10 py-6 text-base md:text-lg",
  xxl: "px-11 py-7 text-base md:text-[17px]",
};

export default function CheckoutButton({
  label = "SÍ, QUIERO ALIMENTAR MEJOR A MI HIJO",
  testId,
  size = "lg",
  variant = "primary",
  showSecure = false,
  fullWidthMobile = true,
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (loading) return;
    setLoading(true);
    trackInitiateCheckout(testId || "cta");
    // Brief delay so the pixel/GA event has time to dispatch before navigation
    setTimeout(() => goToCheckout(), 120);
  };

  const variantClasses =
    variant === "primary"
      ? "bg-[#849983] hover:bg-[#6F856E] text-white shadow-[0_14px_40px_rgba(132,153,131,0.4)] hover:shadow-[0_18px_50px_rgba(132,153,131,0.55)]"
      : variant === "dark"
      ? "bg-[#2A302A] hover:bg-[#1c211c] text-white shadow-[0_14px_40px_rgba(42,48,42,0.35)]"
      : "bg-transparent border border-[#849983] text-[#849983] hover:bg-[#849983]/5";

  return (
    <div
      className={`flex flex-col items-stretch sm:items-start gap-2 ${
        fullWidthMobile ? "w-full sm:w-auto" : ""
      }`}
    >
      <motion.button
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        whileHover={{ y: -2 }}
        whileTap={{ scale: 0.98 }}
        onClick={handleClick}
        disabled={loading}
        data-testid={testId || "checkout-button"}
        className={`group inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wider transition-all duration-300 disabled:opacity-60 ${variantClasses} ${SIZES[size]} ${
          fullWidthMobile ? "w-full sm:w-auto" : ""
        }`}
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        <span>{loading ? "Procesando..." : label}</span>
        {!loading && (
          <ChevronRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        )}
      </motion.button>
      {showSecure && (
        <div className="flex items-center justify-center sm:justify-start gap-1.5 text-[11px] tracking-wide text-[#576057]">
          <Lock className="h-3 w-3" />
          <span>Pago 100% seguro · Acceso inmediato</span>
        </div>
      )}
    </div>
  );
}
